/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./register-privacy-popup.vue.js?vue&type=template&id=6c55b04a!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-popup.vue?vue&type=template&id=6c55b04a"
import script from "./register-privacy-popup.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./register-privacy-popup.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-popup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./register-privacy-popup.vue.postcss?vue&type=style&index=0&id=6c55b04a&prod&lang=postcss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-popup.vue?vue&type=style&index=0&id=6c55b04a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports